export const createSafeFilename = (title, extension) =>
  `${title
    .replace(/[^a-z0-9]/gi, "_")
    .toLowerCase()
    .substring(0, 50)}.${extension}`
